import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy, Check, Users } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { useLanguage } from '@/contexts/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

function CompanyCode() {
  const { t } = useLanguage();
  const [companyCode, setCompanyCode] = useState('');
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    fetchCompanyCode();
  }, []);

  const fetchCompanyCode = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/auth/company-code`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCompanyCode(response.data.company_code);
    } catch (error) {
      console.error('Failed to fetch company code:', error);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(companyCode);
    setCopied(true);
    toast({
      title: 'Copied!',
      description: 'Company code copied to clipboard',
      duration: 2000
    });
    setTimeout(() => setCopied(false), 2000);
  };

  if (!companyCode) return null;

  return (
    <Card className="bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold text-gray-700 flex items-center gap-2">
          <Users className="w-4 h-4" />
          Your Company Code
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between bg-white rounded-lg p-3 border border-blue-200">
          <div>
            <div className="text-2xl font-bold text-blue-600 tracking-wider">
              {companyCode}
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Share this code with your team members
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleCopy}
            className="ml-3"
          >
            {copied ? (
              <Check className="w-4 h-4 text-green-600" />
            ) : (
              <Copy className="w-4 h-4" />
            )}
          </Button>
        </div>
        <p className="text-xs text-gray-600 mt-3">
          Team members can enter this code during registration to join your workspace and access shared data.
        </p>
      </CardContent>
    </Card>
  );
}

export default CompanyCode;
